import * as React from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import {
  Typography,
  Box,
  Button,
  Container,
  TextField,
  CssBaseline,
  Avatar,
  Select,
  MenuItem,
  IconButton,
  CircularProgress,
  Paper,
  FormControl,
  Tabs,
  Tab,
  CardContent,
  Collapse,
  InputAdornment
} from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { connect } from "react-redux";
import { loginIMSAdmin, signUp } from "../../app/store/actions/authActions";
import {
  Navigate,
  NavLink,
  Route,
  Routes,
  useNavigate,
  useParams,
  useSearchParams,
  useLocation
} from "react-router-dom";
import {
  centered_flex_box,
  MainInput,
  MainInputLabel,
  MainPassword,
  main_button,
  StyledInput,
  MainPhone,
  sec_button,
  left_flex_box
} from "../../app/components/Styles";
import { BrandSelect } from "../../app/components/BrandSelect";
import { isMobile } from "react-device-detect";
import { Image, Space, Table } from "antd";
import {
  antTableWrapperSx,
  defaultPaginatedTableProps,
} from "../../app/components/AntTableStyles";
import Logo from "../../app/components/logo.png";
import PropTypes from "prop-types";
import MuiPhoneNumber from "material-ui-phone-number";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";
import { t } from "i18next";
import ImageComponent from "../../app/components/ImageComponent";
import { downloadProductsQRS, getProducts, getVendors } from "../../app/store/actions/imsAdminActions";
import { useEffect } from "react";
import { AddCircleOutline, FilterList, FilterListOff, Search, Print } from "@mui/icons-material";
import { parse } from "papaparse";
import moment from "moment";

export const PrductsList = ({
  getProducts,
  user,
  getVendors,
  vendors,
  products,
  warehouseId,
  downloadProductsQRS,
  isLoading
}) => {
  const navigate = useNavigate();
  const [vendorId, setVendorId] = React.useState(null);
  const [page, setPage] = React.useState(1);
  const [selectedProducts, setSelectedProducts] = React.useState([]);
  const [copies, setCopies] = React.useState(1);
  const [search, setSearch] = React.useState('');
  const [startDate, setStartDate] = React.useState(null);
  const [endDate, setEndDate] = React.useState(null);
  const [showFilters, setShowFilters] = React.useState(false);
  const [showPrint, setShowPrint] = React.useState(false);

  useEffect(() => {
    getProducts({ page, limit: 100, warehouseId, vendorId })
  }, [page])

  useEffect(() => {
    if(page === 1) {
      getProducts({ page, limit: 100, warehouseId, vendorId })
    } else {
      setPage(1)
    }
  }, [vendorId])

  useEffect(() => {
    getVendors({ page: 1, limit: 1000 })
  }, [])

  const handleSearch = () => {
    setPage(1);
    const params = {
      page: 1,
      limit: 100,
      warehouseId,
      vendorId,
      search: search || undefined
    };
    getProducts(params);
  };

  const clearAllFilters = () => {
    setSearch('');
    setVendorId(null);
    setPage(1);
    getProducts({ page: 1, limit: 100, warehouseId });
  };

  const safeNumber = (value) => {
    const n = Number(value);
    return Number.isFinite(n) ? n : 0;
  };

  const mapProductRow = (row) => {
    if (!row || typeof row !== "object") return null;
    try {
      const vendorName =
        row.vendor?.brandName ?? row.vendor?.name ?? null;
      return {
        key: row._id ?? row.sku ?? row.externalId,
        _id: row.sku || row.externalId || row._id || "—",
        image: row.image || null,
        name: row.name ?? "—",
        size: row.size ?? null,
        color: row.color ?? null,
        weight: row.weight ?? null,
        price: row.price ?? null,
        // Hide deleted/missing brand rather than crashing the page
        vendor: vendorName,
        vendorId: row.vendor?._id ?? null,
        product: row,
        amount: Array.isArray(row.stocks)
          ? row.stocks.reduce((sum, stock) => sum + safeNumber(stock?.amount), 0)
          : 0,
        inbounds: row.inbounds,
        inbound: Array.isArray(row.inbounds)
          ? row.inbounds.reduce(
              (sum, inbound) =>
                sum +
                (safeNumber(inbound?.quantity) -
                  safeNumber(inbound?.quantityReceived)),
              0
            )
          : 0,
      };
    } catch (err) {
      console.warn("Skipping broken product row", row?._id, err);
      return null;
    }
  };

  const columns = [
    {
      title: 'Product SKU',
      dataIndex: '_id',
      render: (text) => text ?? "—",
    },
    {
      title: 'Image',
      dataIndex: 'image',
      render: (text) =>
        text ? (
          <ImageComponent width={50} height={50} src={text} preview={true} />
        ) : null,
    },
    {
      title: 'Name',
      dataIndex: 'name',
      render: (text) => text ?? "—",
    },
    {
      title: 'Size',
      dataIndex: 'size',
      render: (text) => text ?? null,
    },
    {
      title: 'Price',
      dataIndex: 'price',
      sorter: (a, b) => safeNumber(a?.price) - safeNumber(b?.price),
      render: (price) => (price != null && price !== "" ? `${price} EGP` : null),
    },
    (window.location.pathname.includes("warehouse") ? {
      title: 'QTY On Hand',
      dataIndex: 'amount',
      defaultSortOrder: 'descend',
      sorter: (a, b) => safeNumber(a?.amount) - safeNumber(b?.amount),
    } : {}),
    (window.location.pathname.includes("warehouse") ? {
      title: 'Inbound',
      dataIndex: 'inbound',
      sorter: (a, b) => safeNumber(a?.inbound) - safeNumber(b?.inbound),
    } : {}),
    {
      title: 'Vendor',
      dataIndex: 'vendor',
      // Deleted / missing brands: leave cell empty
      render: (text) => text ?? null,
    },
  ];

  let data = [];
  try {
    data = (products?.docs ?? []).map(mapProductRow).filter(Boolean);
  } catch (err) {
    console.warn("Failed to build products table data", err);
    data = [];
  }

  const onSelectChange = (newSelectedRowKeys) => {
    console.log('selectedRowKeys changed: ', newSelectedRowKeys);
    setSelectedProducts((newSelectedRowKeys ?? []).map((key) => key).filter(Boolean));
  };

  const rowSelection = {
    selectedProducts,
    onChange: onSelectChange,
  };

  const handlePrintSelected = () => {
    const items = (products?.docs ?? [])
      .filter((row) => row?._id && selectedProducts?.includes(row._id))
      .map((row) => ({
        quantity: copies,
        product: row,
        vendor: row.vendor ?? null,
      }));

    if (items.length === 0) return;
    downloadProductsQRS({ items })
  }

  const handlePrintAllCopies = () => {
    const items = (products?.docs ?? [])
      .filter(Boolean)
      .map((row) => ({
        quantity: copies,
        product: row,
        vendor: row.vendor ?? null,
      }));

    if (items.length === 0) return;
    downloadProductsQRS({ items })
  }

  return (
    <div>
      <Box sx={{ width: "100%", px: 5 }}>
        <Box sx={{ ...centered_flex_box, mb: 2, justifyContent: 'space-between' }}>
          <Typography variant='h4' sx={{ color: "var(--secColor)" }}>Products</Typography>
          <Box>
            <Button
              onClick={() => setShowFilters(!showFilters)}
              sx={{ ...main_button, my: 2, ml: 2 }}
            >
              {showFilters ? <FilterListOff sx={{ color: "var(--secondaryColor)" }} /> : <FilterList sx={{ color: "var(--secColor4)" }} />}
              Filters
            </Button>
            <Button
              onClick={() => setShowPrint(!showPrint)}
              sx={{ ...main_button, my: 2, ml: 2 }}
            >
              {showPrint ? <FilterListOff sx={{ color: "var(--secondaryColor)" }} /> : <Print sx={{ color: "var(--secColor4)" }} />}
              Print
            </Button>
          </Box>
        </Box>
        <Collapse in={showFilters}>
          <CardContent>
            <Box sx={{ display: "flex", flexDirection: "column", px: 5 }}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography>Search</Typography>
                  <MainInput
                    margin="normal"
                    fullWidth
                    placeholder="Search by SKU or product name"
                    value={search}
                    onChange={({ target }) => setSearch(target.value)}
                    onKeyPress={(e) => {
                      if (e.key === 'Enter') {
                        handleSearch();
                      }
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={handleSearch}
                            edge="end"
                            sx={{ color: "var(--secColor4)" }}
                          >
                            <Search />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <BrandSelect
                    vendors={vendors}
                    value={vendorId}
                    label="Vendor"
                    emptyLabel="All Vendors"
                    emptyValue={null}
                    fullWidth
                    margin="none"
                    sx={{ mt: 1 }}
                    onChange={(id) => setVendorId(id)}
                  />
                </Grid>
                <Grid item xs={2} sx={{ ...centered_flex_box }}>
                  <Button sx={{ ...main_button }} fullWidth onClick={() => clearAllFilters()}>Clear All</Button>
                </Grid>
              </Grid>
            </Box>
          </CardContent>
        </Collapse>
        <Collapse in={showPrint}>
          <CardContent>
            <Box sx={{ display: "flex", flexDirection: "column", px: 5 }}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography>Print Options</Typography>
                  <Box sx={{ ...left_flex_box, mt: 2 }}>
                    <MainInput
                      sx={{ marginInlineEnd: 2, minWidth: "20vw" }}
                      defaultValue={copies}
                      label="Copies to Print"
                      onChange={({ target }) => setCopies((target.value))}
                      type="number"
                      inputProps={{
                        min: 1
                      }}
                    />
                    <Button 
                      onClick={() => handlePrintSelected()} 
                      disabled={selectedProducts?.length === 0 || isLoading} 
                      sx={{ ...main_button, mr: 1 }}
                    >
                      {isLoading ? <CircularProgress color="white" /> : `Print ${copies} copies of selected products`}
                    </Button>
                    <Button 
                      onClick={() => handlePrintAllCopies()} 
                      disabled={isLoading} 
                      sx={{ ...main_button, mr: 1 }}
                    >
                      {isLoading ? <CircularProgress color="white" /> : `Print ${copies} copies of all products`}
                    </Button>
                  </Box>
                  <Typography sx={{ ml: 1, mt: 1 }}>
                    {selectedProducts?.length > 0 ? `Selected ${selectedProducts?.length} items` : null}
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          </CardContent>
        </Collapse>
        <Box sx={antTableWrapperSx(isMobile)}>
          <Table
            columns={columns}
            dataSource={data}
            rowSelection={rowSelection}
            loading={isLoading}
            onRow={(record) => ({
              style: record.product?.deletedFromShopify
                ? {
                    backgroundColor: '#ffe5e5',
                    color: '#b71c1c',
                  }
                : {},
            })}
            showSorterTooltip={{
              target: 'sorter-icon',
            }}
            pagination={defaultPaginatedTableProps({
              current: page,
              pageSize: parseInt(products?.limit) || 100,
              total: products?.totalDocs,
              onChange: (nextPage) => setPage(nextPage),
            })}
            scroll={{ x: isMobile ? 300 : 1200 }}
          />
        </Box>
      </Box>
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state?.auth?.user,
  isLoading: state?.records?.isLoading || state?.wait?.isLoading,
  token: state?.auth?.token,
  products: state?.records?.products,
  vendors: state?.records?.vendors
});

const mapDispatchToProps = { getProducts, downloadProductsQRS, getVendors };

export default connect(mapStateToProps, mapDispatchToProps)(PrductsList);
